export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS';



// WEBPACK FOOTER //
// ./js/actions/ConnectionStatus.js